module.exports = __webpack_public_path__ + "img/model_24_ug.f0a5ada6.jpg";